import { useEffect, useRef } from "react";
import { compareIds } from "util/support";
import type { TabsProps } from 'ui/atoms/Tabs';
import { useOnboardingApplicationLogsRequest } from "../hooks";
import { useApplicationTableResourceContext } from "../../../ApplicationTableResourceProvider";
import { OnboardingApplicationLogTab, Resource } from "../types";

export const useOnboardingApplicationLogs = ({ value }: Pick<TabsProps, 'value'>) => {
    const {
        loading,
        toRows,
        fetchOnboardingLogsIfNotExists,
        fetchOnboardingLogs
    } = useOnboardingApplicationLogsRequest();

    const repository = {
        fetchOnboardingLogsIfNotExists
    };

    const repositoryRef = useRef(repository);
    repositoryRef.current = repository;

    const { context } = useApplicationTableResourceContext();

    const applicationId = context?.row.pki;

    useEffect(() => {
        repositoryRef.current.fetchOnboardingLogsIfNotExists({
            applicationId,
            resource: Resource.Applications
        }, () => compareIds(`${value}`, OnboardingApplicationLogTab.Application));
    }, [applicationId, value]);

    return {
        loading,
        rows: toRows(),
        fetchOnboardingLogs
    };
};

export default useOnboardingApplicationLogs;
